import { GraphQLContentMapper } from './GraphQLContentMapper'
import { pageBlockMapper } from './blocks/PageBlockMapper'
import { quizBlockMapper } from './blocks/QuizBlockMapper'
import { videoBlockMapper } from './blocks/VideoBlockMapper'

export const graphqlContentMapper = new GraphQLContentMapper([
  videoBlockMapper,
  pageBlockMapper,
  quizBlockMapper,
])
